import { calculateDistanceBetweenCoordinates } from 'shared/map/lib/utils';
/**
 * @function calcZontMapStats - Считаем статистику по треку
 * @param fuel_consumption - входные данные для потребления топлива
 * @param gps_dump - массив отфильтрованных GPS-точек
 * @param from - с какого времени
 * @param to - по какое время
 * @return StatsResult
 */
export function calcZontMapStats_(fuel_consumption, gps_dump, from, to) {
    if (from == null) {
        from = 0;
    }
    if (to == null) {
        to = gps_dump.length;
    }
    let duration = 0;
    let distance = 0;
    let consumption = 0;
    let max_speed = 0;
    const fuel = fuel_consumption;
    const show_calculated_fuel_consumption = fuel && fuel.enabled;
    const fuel_consumption_idle = fuel ? fuel.idle : null;
    const fuel_consumption_100km = fuel ? fuel.km100 : null;
    const max_mass_koef = 5; //Не спрашивай, что это значит :)
    let prev = null;
    for (let i = from; i < to; i++) {
        const cur = gps_dump[i];
        // This filtering now done via accuracy limit
        //
        // if (cur && cur.prov != null && cur.prov != UI.TrackingManager.prototype.COORD_PROVIDER_GPS)
        //     continue
        if (cur != null && cur.speed != null)
            max_speed = Math.max(max_speed, cur.speed);
        if (prev != null && cur != null) {
            // meters
            const delta_s = calculateDistanceBetweenCoordinates(prev.loc, cur.loc);
            distance += delta_s;
            if (cur.speed != null && prev.speed != null) {
                const delta_t = (cur.time.getTime() - prev.time.getTime()) / 1000; // seconds
                if (delta_t < 5 * 60) {
                    duration += delta_t;
                }
                if (show_calculated_fuel_consumption &&
                    fuel_consumption_idle != null &&
                    fuel_consumption_100km != null) {
                    if (delta_t < 5 * 60) {
                        const speed = (cur.speed + prev.speed) / 2; // km/h
                        // Magic formula
                        if (speed < 0.6)
                            consumption += (delta_t / 3600) * fuel_consumption_idle;
                        else if (speed < 10)
                            consumption +=
                                ((fuel_consumption_100km * delta_s) / 100000) *
                                    max_mass_koef;
                        else
                            consumption += (fuel_consumption_100km * delta_s) / 100000;
                    }
                }
            }
        }
        prev = cur;
    }
    let price = null;
    if (fuel && fuel.price != null)
        price = consumption * fuel.price;
    return {
        duration: duration,
        distance: distance,
        avg_speed: duration !== 0 ? distance / duration : null,
        max_speed: max_speed,
        fuel: {
            consumption: show_calculated_fuel_consumption ? consumption : null,
            avg_consumption: fuel_consumption_100km,
            price: price,
        },
    };
}
